export const startOf = (date, unit) => {
  const newDate = new Date(date)

  switch (unit) {
    case 'day':
      newDate.setHours(0, 0, 0, 0)
      break
    case 'week':
      const day = newDate.getDay()
      newDate.setDate(newDate.getDate() - day) // Go back to the previous Sunday
      newDate.setHours(0, 0, 0, 0)
      break
    case 'month':
      newDate.setDate(1)
      newDate.setHours(0, 0, 0, 0)
      break
    case 'year':
      newDate.setMonth(0)
      newDate.setDate(1)
      newDate.setHours(0, 0, 0, 0)
      break
  }
  return newDate
}
